import { Br } from "@/components/molecules/Br";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import Contact from "@/components/organisms/Contact";
import IdentityNav from "@/components/organisms/IdentityNav";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import Image from "next/image";
import Scrollspy from "react-scrollspy";
import CoverSec from "/public/cover-sec.webp";
import Identity from "/public/identity.svg";

const cultureLists = [
  {
    index: "1",
    section: "section01",
    sectionUnchor: "#section01",
    title: "お客さまのために",
    body: "すべての判断と行動は、お客さまへの価値提供につなげるために行う。<br class='br_xl' />間接部門も同様に、より良い顧客価値を提供するために、直接部門への価値提供を行う。",
    src: "/culturePhoto1.webp",
  },
  {
    index: "2",
    section: "section02",
    sectionUnchor: "#section02",
    title: "自分自身の成長のために",
    body: "お客さまや相手に対し、より良い価値を提供しようとすることは、<br class='br_xl' />仕事を良い方向に導くだけでなく、自身の成長と価値向上にもつながるものだと考え行動する。",
    src: "/culturePhoto2.webp",
  },
  {
    index: "3",
    section: "section03",
    sectionUnchor: "#section03",
    title: "主体性のある姿勢を持つ",
    body: "<p>主体性のある姿勢は、社会により多くの価値を提供するだけでなく、自分自身の思考力や提案力、<br class='br_xl' />そして価値を向上させると考え行動する。</p><p>私たちは、様々な場面で新たな仕組みや価値を生み出すために仕事します。<br class='br_xl' />そのためには、一人一人が単なる作業者ではなく、主体性をもってお客さまやサービスと向き合い、<br class='br_xl' />自身で考え判断し、自信を持って関係者に前向きに働きかけることが重要です。</p>",
    src: "/culturePhoto3.webp",
  },
  {
    index: "4",
    section: "section04",
    sectionUnchor: "#section04",
    title: "自分ごととして考える",
    body: "<p>責任感を育み、自己の行動を規律し、前向きな良い仕事を遂行する。</p><p>お客さまから見れば、会社内の全ての社員は、職位や立場に関わらず、一人一人が会社の代表者です。<br class='br_xl' />仕事上で起こる物事やお客さまからの一言一句に対し、「自分の仕事ではない」「誰かがやるだろう」とは考えず、<br class='br_xl' />常に当事者意識を持って自身の課題として取り組むことが重要です。</p>",
  },
  {
    index: "5",
    section: "section05",
    sectionUnchor: "#section05",
    title: "誠実に取り組む",
    body: "<p>各々がどうすればより良くできるかを考え、誠実に取り組み、その姿勢を内外に示すことが、<br class='br_xl' />自己の利益になると考え行動する。</p><p>私たちの仕事は、お客さま、社内、関係者との信頼関係に基づいて成り立っています。<br class='br_xl' />相手を欺く行為や手を抜く取り組みは、信頼関係を傷つけ、結果的に私たちの仕事が成り立たなくなることを<br class='br_xl' />理解しなければなりません。</p>",
    src: "/culturePhoto4.webp",
  },
  {
    index: "6",
    section: "section06",
    sectionUnchor: "#section06",
    title: "目的志向で率直なコミュニケーションを",
    body: "<p>目標達成のために、だれもが等しく言語化して率直なコミュニケーションをとることを大切にする。</p><p>お客さまの価値の最大化に向け、どのように進むべきか、どうすればより良くできるのか。<br class='br_xl' />こういった議論においては、社長から新入社員まで立場は無関係です。<br class='br_xl' />社内における立場（職位）は、お客さまの価値を最大化するための組織的な役割分担にすぎません。</p>",
    src: "/culturePhoto5.webp",
  },
  {
    index: "7",
    section: "section07",
    sectionUnchor: "#section07",
    title: "感謝を言葉にして伝える",
    body: "<p>心からの感謝を常日頃から言葉にして伝える。</p><p>私たちは社会的な存在であり、どんなに優れた能力を持っていても、一人では大きな成果を生むことはできません。<br class='br_xl' />多くの会社が存在する中で、共に成長し、問題解決に取り組むパートナーとして、私たちを選択してくれること。<br class='br_xl' />また、私たちを信頼して、選び続けてくれることは、どちらも当たり前のことではなく、<br class='br_xl' />お客さまからの信頼の気持ちに対して感謝を示さなければなりません。</p><p>一緒に仕事を進めてくれる仲間、部下、上司、取引先など、自分の依頼や言葉に応えてくれる、<br class='br_xl' />または自分を頼って行動してくれる、一人一人に感謝を示さなければなりません。</p>",
    src: "/culturePhoto6.webp",
  },
  {
    index: "8",
    section: "section08",
    sectionUnchor: "#section08",
    title: "現場主義でスピーディーかつ有機的に",
    body: "<p>私たちの事業は、お客さまにより良い価値を提供するために存在する。</p><p>現場の仕事において、自分たちのためではなく、お客さまのための意思決定や判断をする。<br class='br_xl' />迅速に適切な答えが返ってくることは高い顧客価値となります。</p><p>反面、不要なエスカレーションは遅延を生み、遅延は顧客価値を損ないます。<br class='br_xl' />正しい知識と前提を持った判断は、最も近くで情報に触れている、現場の判断が、<br class='br_xl' />往々にして最も正しいものであると心得え、できる限り現場で責任を持って行動する。<br class='br_xl' />しかし、自身の裁量範囲を超える場合は、迅速かつ遠慮なくエスカレーションを行う。</p>",
    src: "/culturePhoto7.webp",
  },
  {
    index: "9",
    section: "section09",
    sectionUnchor: "#section09",
    title: "頭は常にフル回転で時間は最短に",
    body: "<p>時間あたりの価値を向上させることが、自分自身の価値を高める一歩と考えて行動する。<br class='br_xl' />労働時間の長さよりも、生み出された価値が重要です。</p><p>仕事をするときは、頭をフルに活用し、最短時間で業務を遂行。そして、しっかり休んでリフレッシュする。<br class='br_xl' />無駄な長時間労働は生産性を下げ、自身の時間あたりの労働価値を低下させます。</p>",
    src: "/culturePhoto8.webp",
  },
  {
    index: "10",
    section: "section10",
    sectionUnchor: "#section10",
    title: "情報（価値）を積極的に発信する",
    body: "<p>積極的な情報発信は、自己学習だけでは得られない新たな成長の機会と考え行動する。</p><p>積極的に他者のために情報を発信する人に、新たな情報は集まります。発信力を高めることで、自身の価値を高め、他者に貢献できます。次第に、情報交換を求める人々が集まり、自身だけでは得ることのできない情報や、有益だと気がつけない新たな気づきを得られます。</p>",
    src: "/culturePhoto9.webp",
  },
  {
    index: "11",
    section: "section11",
    sectionUnchor: "#section11",
    title: "働く人を大切にする",
    body: "<p>技術を支えるのは常に人であることを忘れず、仕事に携わる人々の満足度を高めることを意識して行動する。<br class='br_xl' />お客さまの満足度を向上させるためには、現場の一人一人が、前向きかつ積極的に取り組める環境を整えることが重要です。</p>",
  },
];

export default function CulturePage(props) {
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={"価値観・カルチャー"}
        pageDescription={
          "株式会社トッカシステムズの価値観・カルチャーです。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/identity/culture"}
      />
      <Layout className="relative">
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            <div className="w-full">
              <div className="relative col-span-1 w-full cursor-pointer overflow-hidden px-6 py-8 sm:px-8 md:px-12 md:py-0 lg:py-20 lg:px-12 xl:px-0">
                <div className="">
                  <div className="relative z-10 mx-auto w-full max-w-7xl space-y-6 text-white xl:space-y-12">
                    <h2 className="relative aspect-[9.9375/1] h-[18px] w-auto md:h-[24px] lg:h-[20px]">
                      <Image src={Identity} quality={80} layout="fill" />
                    </h2>
                    <div className="space-y-4">
                      <h3 className="font-serif font-bold fluid-text-[22px,45px]">
                        価値観・カルチャー
                      </h3>
                      <div className="fluid-text-[12px,18px]">
                        私たちは、事業を推進していくため、仲間とともに充
                        <Br sp />
                        実した職業人生を
                        <Br tbpc />
                        歩んでいくための
                        <Br sp />
                        価値観・カルチャーを共有します
                      </div>
                    </div>
                  </div>
                  <div className="absolute top-1/2 left-1/2 z-0 aspect-[4.24/1] h-full w-full -translate-x-1/2 -translate-y-1/2 lg:h-full xl:h-[400px]">
                    <Image src={CoverSec} quality={80} layout="fill" />
                  </div>
                </div>
              </div>
            </div>
            <Inner className="mx-auto box-border flex max-w-7xl flex-col gap-6 p-6 sm:gap-8 sm:p-8 md:gap-12 md:p-12 lg:py-16 xl:px-0">
              <div className="grid grid-cols-1 md:grid-cols-4">
                <div className="col-span-3">
                  <div className="flex flex-col gap-10 lg:gap-20">
                    {cultureLists.map((culture) => (
                      <div
                        id={culture.section}
                        key={culture.id}
                        className="--offset flex flex-col gap-3 lg:gap-8"
                      >
                        <h2 className="inline-flex items-center font-serif font-bold leading-none text-pri fluid-text-[18px,32px]">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="h-6 w-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5l-3.9 19.5m-2.1-19.5l-3.9 19.5"
                            />
                          </svg>
                          {culture.title}
                        </h2>
                        <div
                          className="flex flex-col gap-3 leading-6 text-txt-base fluid-text-[14px,18px] md:gap-6 md:leading-7 lg:leading-9"
                          dangerouslySetInnerHTML={{
                            __html: `${culture.body}`,
                          }}
                        />
                        {culture.src && (
                          <div
                            className={`relative h-auto w-full ${
                              culture.index === "1" || culture.index === "3"
                                ? "aspect-[3.563/1]"
                                : "aspect-16/9"
                            }`}
                          >
                            <Image
                              src={`${culture.src}`}
                              quality={80}
                              layout="fill"
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="relative col-span-1 hidden pl-16 text-txt-light fluid-text-[12px,14px] md:block">
                  <div className="sticky space-y-8 lg:top-[120px] xl:top-[120px]">
                    <h3 className="font-bold">INDEX</h3>
                    <Scrollspy
                      className="space-y-2"
                      items={[
                        "section01",
                        "section02",
                        "section03",
                        "section04",
                        "section05",
                        "section06",
                        "section07",
                        "section08",
                        "section09",
                        "section10",
                        "section11",
                      ]}
                      currentClassName="text-pri font-bold"
                    >
                      {cultureLists.map((culture) => (
                        <li key={culture.index}>
                          <a
                            href={culture.sectionUnchor}
                            className="hover:text-txt-base"
                          >
                            {culture.title}
                          </a>
                        </li>
                      ))}
                    </Scrollspy>
                  </div>
                </div>
              </div>
              <IdentityNav showGuidelinesLink={true} showCultureLink={false} />
            </Inner>
          </Container>
        </main>
        <Contact>
          ご応募や採用に関するお問い合わせ／ご連絡をお待ちしております。
          <br />
          まずはお気軽にお問い合わせください。
        </Contact>
        <Footer />
      </Layout>
    </>
  );
}
